





































import { Component, Prop, Vue } from 'vue-property-decorator'
import CardItem from '@/components/home/CardItem.vue'
import { CardList, Card } from '@/types/Card'
import HomeModule from '@/store/home'
@Component({
  name: 'CardSlider',
  components: {
    CardItem
  }
})
export default class CardSlider extends Vue {
  @Prop() readonly currentCardList!: CardList
  private model = null

  private async setCardlist(): Promise<void> {
    await HomeModule.setCardList(this.currentCardList)
    this.$router.push({
      name: 'AllCards',
      params: { cardListId: this.currentCardList._id }
    })
  }
}
